import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => ({
    titleBox: {
        fontWeight: 600,
        fontStyle: 'normal',
        letterSpacing: '0px',
        color: '#69716F',
        opacity: 1,
    },
    contentBox: {
        font: 'normal normal normal 16px/24px Arial',
        letterSpacing: '0px',
        color: '#898B8B',
        opacity: 1,
    },
    link: {
        color: 'black',
    },
    formLabelBlock: {
        display: 'block',
    },
    flex: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    modal: {
        position: 'absolute' as 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: 'white',
    },
    dialogTitle: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        '& h2': {
            paddingLeft: '20px',
        },
    },
    infoLink: {
        color: "inherit",
        fontWeight: 'bold',
        transition: 'opacity 0.3s',
        '&:hover': {
            opacity: 0.8,
        }
    },
    longLabelText: {
        alignItems: 'center',
        '& .MuiFormLabel-root': {
            marginTop: '0 !important',
            whiteSpace: 'normal !important'
        }
    },
    overlay: {
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        background: 'rgba(255,255,255)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: '9999999999',
        fontSize: '24px',
        textAlign: 'center',
        fontWeight: 600,
    },
    overlayContent: {
        display: 'grid',
        justifyItems: 'center',
        gap: '30px',
        maxWidth: '470px',
    }
}))

export default useStyles
